import { LocalDate, LocalDateTime } from "@js-joda/core";
import api from "@modules/api/api";
import { useQuery } from "@tanstack/react-query";
import dropOffLocationQueryKeys from "../dropOffLocationQueryKeys";

const performGet = async (
  dropOffLocationId: string,
  startDate: LocalDate,
  endDate: LocalDate
) => {
  return api.get<{ unavailableSlots: string[] }>(
    `api/drop-off-locations/${dropOffLocationId}/unavailable-hours?startDate=${startDate}&endDate=${endDate}`
  );
};

export default function useUnavailableHoursForPeriod(
  dropOffLocationId: string | undefined,
  startDate: LocalDate,
  endDate: LocalDate
) {
  const { data } = useQuery({
    queryKey:
      dropOffLocationQueryKeys.unavailableSlotsForDateIntervalByLocation(
        dropOffLocationId as string,
        startDate,
        endDate
      ),
    queryFn: () => performGet(dropOffLocationId as string, startDate, endDate),
    enabled: !!dropOffLocationId,
    select: ({ unavailableSlots }) =>
      unavailableSlots.map((item) => LocalDateTime.parse(item)),
  });

  return { unavailableSlots: data ?? [] };
}
